import * as React from "react";
import { observer } from "mobx-react";
import { LoginStore } from "../modules/login/LoginStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import Project from "../modules/project/components/pages/Project";
import { Redirect } from "react-router-dom";

type IStates = {
  isVisible: boolean;
};
type IProps = {
  classes: any;
  match: any;
};

export const VerifySession = ({ render }) => {
  if (LoginStore.expiredTrial()) {
    return <Redirect from="/menu/development" to="/menu/development" />;
  }

  if (LoginStore.userAuth) {
    if (!LoginStore.trialUserIsVerified()) {
      return <Redirect from="/check-email" to="/check-email" />;
    }

    return render();
  }

  console.error("Autheticated user not found!");
  return <></>;
};

@observer
class PrivateRouteProject extends React.Component<IProps, IStates> {
  constructor(props: any) {
    super(props);

    this.state = {
      isVisible: false,
    };

    this._auth();
  }

  /**
   * Auth event for private routes
   */
  _auth = async () => {
    try {
      // Await user validation
      await DevelopmentStore.setDevelopmentSelected(this.props.match.params.id);
      this.setState({ isVisible: true });
    } catch (e) {
      this.setState({ isVisible: true });
    }
  };

  public render() {
    if (!this.state.isVisible) return <div />;
    return <VerifySession render={() => <Project {...this.props} />} />;
  }
}

export default PrivateRouteProject;



// WEBPACK FOOTER //
// ./src/common/PrivateRouteProject.tsx